/* eslint-disable react/jsx-wrap-multilines */
import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { notification } from 'antd';
import Container from 'components/Containers/Container';

import OlympicResults from 'modules/Olympic/components/OlympicResults';
import { sendEmail } from 'helpers/MailHelper';
import { sendResult } from 'services/StudentService';
import { encrypt, decrypt } from '../../helpers/CryptoHelper';

// import data from './data.json';

export default ({ match }) => {
  // Redux
  const loggedInUser = useSelector((state) => state.authReducer.loggedInUser);
  const examination = useSelector((state) => state.olympicReducer.examination);
  const submittedQuestions = useSelector((state) => state.olympicReducer.submittedQuestions);

  // console.log(submittedQuestions);

  const correctQuestions = _.reduce(
    submittedQuestions,
    (sum, item) => {
      const value = item.userData.result ? 1 : 0;
      return sum + value;
    },
    0,
  );

  const total = examination.questions.length;

  React.useEffect(() => {
    const sendResultAndSendEmail = async () => {
      let answersStringBulder = '';
      submittedQuestions.forEach((item, index) => {
        answersStringBulder += `
        <div class='circle' style='background-color: ${item.userData.result ? '#2dce89' : '#f5365c'}'>
          <span>${index + 1}</span>
        </div>`;
      });

      const subject = `OLYMPIC: Kết quả bài thi của ${loggedInUser.fullName} - Ngày ${moment().format('DD/MM/YYYY HH:mm')}`;
      const htmlBody = `
      <html>
        <head>
          <style>
            .circle {
              margin: 4px;
              height: 32px; 
              width: 32px; 
              border-radius: 16px; 
              float: left;
              text-align: center;
              vertical-align: middle;
              line-height: 32px;
              color: white;
              font-weight: 600;
              font-size: 14px;
            }
          </style>
        </head>
        <body id="body">
          <div style='font-family: Roboto!important'>
            <p style='font-size: 13pt'>Chúc mừng thí sinh ${loggedInUser.fullName}!</p>
            <h2>Bạn đã hoàn thành bài thi của cuộc thi SACHSO - OLYMPIC ENGLISH</h2>
            <p style='font-size: 13pt'>Ngày hoàn thành: ${moment().format('DD/MM/YYYY HH:mm')}</p>      
  
            <h2>Kết quả bài thi:</h2>
            <div style='border: 3px dashed blue; border-radius: 12px; display: inline-flex; width: 448px'>
              <div style='padding: 24px;'>                      
                <table>                        
                  <tr>
                    <td rowspan='2' style='padding-right: 24px'>
                      <img src='https://cloud.softech.vn/storage/sachso/images/share/success-512.png' style='width: 64px' alt='Sách số'/>
                    </td>
                    <td style='font-size: 13pt; color: blue'><strong>Kết quả:</strong></td>
                    <td style='font-size: 13pt; font-weight: 700; color: red'>${correctQuestions} / ${total} (câu hỏi)</td>
                  </tr>
                  <tr>
                  <td style='font-size: 13pt; color: blue'><strong>Đạt tỷ lệ:</strong></td>
                  <td style='font-size: 13pt; font-weight: 700; color: red'>${numeral(correctQuestions / total).format('0.00%')}</td>
                </tr>
                </table>
              </div>
            </div>
  
            <h2>Chi tiết làm bài:</h2>
            <div style='border: 3px dashed blue; border-radius: 12px; display: inline-flex; width: 448px'>
              <div style='padding: 24px;'>   
                ${answersStringBulder}
              </div>
            </div>
  
            <div style='overflow: auto; clear: both; margin-top; 48px'>
              <p>
                <hr />
                <address>
                  Hệ thống gửi email tự động - SACHSO
                </address>
              </p>  
            </div>
          </div>
        </body>
      </html>
      `;

      // NOTE: Mã hóa kết quả bài thi
      const compactSubmittedQuestions = submittedQuestions.map((x) => {
        return { questionId: x.question.id, result: x.userData.result };
      });
      const sqsMessage = {
        user: { id: loggedInUser?.id, email: loggedInUser.email },
        examination: { id: examination.id, code: examination.code, classLevel: examination.classLevel },
        results: compactSubmittedQuestions,
      };
      const sqsMessageString = JSON.stringify(sqsMessage);
      const sqsMessageEncrypted = encrypt(sqsMessageString);

      // NOTE: Gửi về AWS
      const response = await sendResult({
        user: { id: loggedInUser?.id, email: loggedInUser.email },
        examination: { id: examination.id, code: examination.code, classLevel: examination.classLevel },
        message: sqsMessageEncrypted,
        // messageAttributes: {
        //   userId: {
        //     DataType: 'Number',
        //     StringValue: loggedInUser?.id.toString(),
        //   },
        // },
      });

      // NOTE: Gửi thành công.
      if (response.status === 200) {
        console.log(response.data);
      }

      // NOTE: Gửi email kết quả
      await sendEmail(subject, htmlBody, loggedInUser.email);

      // NOTE: Thông báo
      notification.info({
        message: 'Gửi kết quả về máy chủ thành công',
        description: 'Bạn hãy kiểm tra email để xem kết quả chi tiết',
        duration: 5,
        onClose: () => {
          // FIXME: Quay về olympic/home
          // history.push('/lms/olympic/home');
        },
      });
    };

    // sendResultAndSendEmail();
  }, []);

  return (
    <Container name='Kết quả làm bài' parentName='Olympic English'>
      <div>
        <OlympicResults data={submittedQuestions} examination={examination} loggedInUser={loggedInUser} />
      </div>
    </Container>
  );
};
